export const PayloadCompany = {
  methods: {
    getFavoriteCompanyPayload(idEconomicGroup, item, favorite) {
      // Devo alterar o status de favorito toda
      // vez que clicar nele
      let payload = {
        idEconomicGroup: idEconomicGroup,
        idTaker: item.id,
        favorite: favorite,
        item: item
      };
      return payload;
    }
  }
};
